// web/src/hooks/useIdleTimeout.ts — Auto-logout after a period of inactivity.
//
// Starts a timer on mount. Any activity event (mouse, keyboard, scroll, touch)
// resets the timer. When the timer fires the user is logged out via authStore.
// Only active while the user is authenticated — safe to call unconditionally.
import { useEffect, useRef } from "react";
import { useAuthStore } from "../stores/authStore";
import { IDLE_TIMEOUT_MS, IDLE_ACTIVITY_EVENTS } from "../lib/displayConfig";
export function useIdleTimeout() {
    const logout = useAuthStore((s) => s.logout);
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    const timerRef = useRef(null);
    useEffect(() => {
        if (!isAuthenticated())
            return;
        function reset() {
            if (timerRef.current)
                clearTimeout(timerRef.current);
            timerRef.current = setTimeout(logout, IDLE_TIMEOUT_MS);
        }
        // Start the initial timer and attach activity listeners.
        reset();
        for (const event of IDLE_ACTIVITY_EVENTS) {
            window.addEventListener(event, reset, { passive: true });
        }
        return () => {
            if (timerRef.current)
                clearTimeout(timerRef.current);
            for (const event of IDLE_ACTIVITY_EVENTS) {
                window.removeEventListener(event, reset);
            }
        };
        // logout is stable (Zustand action). isAuthenticated is a function —
        // read at effect-run time only, not tracked as dep.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logout]);
}
